import React from 'react'
import Link from 'next/link'
import { useTrans } from '@next-nx/hooks'
import {
  Close,
  Logo,
} from '@next-nx/shared-ui/icons'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import styles from './HeaderSimple.module.sass'

interface Props {
  className?: string
  setSearchActive: (v: boolean) => void
  handleTracking?: (t: string, r: string, e: boolean) => void
}

const HeaderSimple = (props: Props) => {
  const { className = '', setSearchActive = () => {}, handleTracking = () => {} } = props
  const t = useTrans()

  return (
    <>
      <header className={`${styles.header} ${className}`}>
        <div className={styles.main}>
          <WContainer variant='lg'>
            <div className={styles.mainContent}>
              <Link href="/">
                <a className={styles.logo}>
                  <Logo />
                </a>
              </Link>
              <div className={styles.actions}>
                <Button label={t("Chiudi")} onClick={() => {
                  setSearchActive(false)
                  handleTracking('chiudi', '-', true)
                  }} icon={<Close />} iconPos="right" color="lightblue" variant="ghost" />
              </div>
              <div className={styles.actionsMobile}>
                <Button icon={<Close />} onClick={() => {
                  setSearchActive(false)
                  handleTracking('chiudi', '-', true)
                  }} iconPos="right" color="lightblue" variant="ghost" />
              </div>
            </div>
          </WContainer>
        </div>
      </header>
    </>
  )
}

export default HeaderSimple
